import Typography from '@material-ui/core/Typography';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import Footer, { footerHeight } from 'components/Footer';
import Header from 'components/Header';

const useStyles = makeStyles({
  content: {
    display: 'flex',
    minHeight: '100vh',
    paddingTop: '4.4rem',
    paddingBottom: footerHeight,
    background: '#E5E5E5',
  },
  left: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    padding: '2.5em',
    width: '100%',
    maxWidth: '450px',
    margin: '3em',
    textAlign: 'center',
  },
  title: {
    maxWidth: '600px',
    marginBottom: '2rem',
    textTransform: 'uppercase',
    fontSize: '48px',
    fontWeight: 600,
    lineHeight: '50px',
    '&:after': {
      content: '""',
      width: '70px',
      height: 0,
      borderBottom: '1px solid #212121',
      paddingBottom: '1rem',
      display: 'block',
      margin: 'auto',
    },
  },
  right: {
    width: '40%',
    background:
      "repeating-linear-gradient( 135deg, transparent, transparent 10px, rgba(255, 255, 255, 1) 10px, rgba(255, 255, 255, 1) 12px), url('/home_aside_v2.png')",
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
});

interface Props {
  title: string;
  subtitle?: string;
  children?: any;
  classes?: any;
}

const Layout: React.FC<Props> = ({ title, children, subtitle, classes: propClasses }) => {
  const classes = useStyles({ classes: propClasses });

  return (
    <>
      <Header />
      <div className={classes.content}>
        <div className={classes.left}>
          <Paper elevation={0} className={classes.paper}>
            <Typography variant="h1" className={classes.title}>
              {title}
              {subtitle !== undefined && (
                <>
                  <br />
                  {subtitle}
                </>
              )}
            </Typography>
            {children}
          </Paper>
        </div>
        <aside className={classes.right}></aside>
      </div>
      <Footer />
    </>
  );
};
export default React.memo(Layout);
